<template>
  <div class="enterprise-login">
    <div class="login-title">
      <!-- <img alt="" src="../../assets/images/enterpriseAuth/title_arrow.png"/> -->
      <span>机构注册认证</span>
    </div>
    <div class="login-desc">
      <ul>
        <li>1、请先选择您当前使用的legalXchain司法联盟链体系下的平台；</li>
        <li>2、帐号归属机构，适用群体为企业、党政及国家机关、事业单位、民办非企业单位、社会团体、社会组织；</li>
        <li>3、进行机构认证前需要先完成个人实名认证；</li>
        <li>4、认证信息提交后，我们将会在1个工作日完成审核，请耐心等待；</li>
        <li>5、认证过程中遇到问题，请拨打客服电话处理：400-8650-010；</li>
      </ul>
    </div>
    <div class="login-info">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForms" label-width="100px" class="demo-ruleForm">
        <el-form-item label="选择平台：" prop="dappId">
          <el-select v-model="ruleForm.dappId" placeholder="请选择使用的平台">
            <el-option v-for="item in queryDapp" :label="item.dappName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账号：" prop="account">
          <el-input placeholder="请输入手机号/邮箱" v-model="ruleForm.account" ></el-input>
          <span class="login-error">{{ loginMsg }}</span>
        </el-form-item>
        <el-form-item label="验证码："  prop="vcode">
          <el-input maxlength="15" v-model="ruleForm.vcode" placeholder="请输入验证码"> 
            <template slot="append"><span @click="getVcode">{{ vcodeText }}</span></template>
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="密码："  prop="password">
          <el-input placeholder="请输入字母和数字组成的6~18位密码" type="password" v-model="ruleForm.password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="confirmPassword">
          <el-input placeholder="请再次输入密码" type="password"  v-model="ruleForm.confirmPassword"></el-input>
        </el-form-item> -->
        <el-form-item label="" prop="checked" class="check-item">
          <el-checkbox class="login-info-checked-con" v-model="ruleForm.checked"></el-checkbox><span class="login-info-checked-text">我已阅读并同意</span><span class="login-info-checked" @click="goAgreement">《legalXchain司法联盟链用户注册协议》</span>
        </el-form-item>
      </el-form>
    </div>
    <button type="botton" :disabled="nextStepStatus" @click="submitFrom">{{ loginBtn }}</button>
  </div>
</template>

<script>
import { validateMobile, validateEmail,validatePassword } from "@/utils/validate";

export default {
data() {
  //所选平台
  const dappId = (rule, value, callback) => {
    if (value && value !='') {
        callback();
    } else {
      callback(new Error("请选择使用的平台"));
    }
  };
  //验证账号
  const accountAndemila = (rule, value, callback) => {
    if (value != '') {
      if (validateMobile(value) || validateEmail(value)) {
        this.$refs['ruleForms'].validateField('dappId',(val)=>{
        if(!val){
        this.$ajax({
            url:"/webapi/user/getAccountInfo",
              method:"GET",
              params:{
                dappId:this.ruleForm.dappId,
                encryptAccount:this.setEncrypt(this.ruleForm.account),
              }
            }).then(res => {
              if (res.data.code == 200) {
               //校验是不是子账号 accountType ==3是
               if(res.data.extraData.loginResult.loginUser.accountType !=3){
                //校验账号是否企业已实名 status == 2是
                if(res.data.extraData.enterpriseAuthStatus && res.data.extraData.enterpriseAuthStatus.status == 2){
                  callback(new Error('您已是机构帐号不可再次认证'));
                  this.realNameStatus=false;
                }else{
                  //不是子账号，还未实名进行下一步
                  callback();
                  this.realNameStatus=true;
                }
               }else{
                callback(new Error('您是机构帐号的子帐号不可进行机构帐号认证'));
                this.realNameStatus=false;
               }
              }else{
                callback(new Error(res.data.message));
                this.realNameStatus=false;
              }
            });
          }
      })
      }else{
        callback(new Error("请输入正确的手机号或邮箱"));
      }
    } else {
      callback(new Error('请输入手机号或邮箱'));
    }
  };
  //验证密码
  // const passwordCheck = (rule, value, callback) => {
  //   if (value != '') {
  //     if (!validatePassword(value)) {
  //       callback(new Error("请输入字母和数字组成的6~18位密码"));
  //     }else{
  //       callback();
  //     }
  //   } else {
  //     callback(new Error('请输入密码'));
  //   }
  // };
  //验证勾选同意
  const checkedVal=(rule, value, callback)=>{
    console.log(value,'value')
    if (value) {
      callback();
    } else {
      callback(new Error("请勾选阅读并同意"));
    }
  }
  // //验证确认密码
  // const confirmPasswordCheck = (rule, value, callback) => {
  //   if (value != '') {
  //     if (this.ruleForm.password == value) {
  //       callback();
  //     }else{
  //       callback(new Error("两次输入密码需保持一致"));  
  //     }
  //   } else {
  //     callback(new Error('请输入密码'));
  //   }
  // };
  //验证码
  const vcodeCheck=(rule, value, callback) => {
    if (value != '') {
        if(value.length == 6){
          callback();
        }else{
          callback(new Error('验证码错误'));
        }
    } else {
      callback(new Error('请输入验证码'));
    }
  };
  return {
    ruleForm: {
      vcode: "",//验证码
      account: "",//账号
      dappId: "",//所选平台
      password:"",//密码
      confirmPassword:"",//再次输入密码
      checked:"",//勾选同意协议
    },
    vcodeText:"获取验证码",
    //获取验证码时长
    countDown:0,
    //是否可点击获取验证码按钮
    getCode:false,
    //表单验证
    rules: {
      dappId: [
        {
          required: true,
          validator: dappId,
          trigger: "change"
        }
      ],
      account: [
        {
          required: true,
          validator: accountAndemila,
          trigger: "blur"
        }
      ],
      vcode: [
        {
          required: true,
          validator: vcodeCheck,
          trigger: "blur"
        }
      ],
      // password: [
      //   {
      //     required: true,
      //     validator: passwordCheck,
      //     trigger: "blur"
      //   }
      // ],
      // confirmPassword: [
      //   {
      //     required: true,
      //     validator: confirmPasswordCheck,
      //     trigger: "blur"
      //   }
      // ],
      checked: [
        {
          required: true,
          validator: checkedVal,
          trigger: "change"
        }
      ],
    },
    //公钥
    pubKey: "",
    //平台列表
    queryDapp:[],
    nextStepStatus:false,
    loginMsg:"",
    loginBtn:"下一步",
    //账号实名状态 false-未实名，true已实名
    realNameStatus:false 
  };
  
},
computed: {
  lanInfo() {
    return this.$store.getters.getLanInfo.ContactUs;
  },
  lanType() {
    return this.$store.getters.getLanType;
  }
},
mounted() {
  this.getUrlList();
  this.getEncryptPubKey();
},
methods: {
  //获取平台列表
  getUrlList(){
    this.$ajax
      .get("/webapi/blockchainDapp/queryDapp")
      .then(res => {
        if (res.data.code == 200) {
          this.queryDapp=res.data.extraData.dappList;
        }
      });
    },
  //获取验证码
  getVcode () {
    if(!this.getCode ){
      //验证账号
      this.$refs['ruleForms'].validateField('account',(val)=>{
        if(!val && this.realNameStatus){
          //设置倒计时
          this.getCode = true;
          this.countDown = 59;
          this.vcodeText=this.countDown+'s'
          this.timer = setInterval(() => {
            this.countDown--;
            this.vcodeText=this.countDown+'s';
            if (this.countDown == 1) {
              this.getCode = false;
              this.countDown = 59;
              this.vcodeText='获取验证码';
              clearInterval(this.timer);
            }
          }, 1000);
          //验证码请求路径
          this.$ajax({
            url:"/webapi/user/sendCode",
              method:"GET",
              params:{
                encryptAccount:this.setEncrypt(this.ruleForm.account),
              }
            }).then(res => {
              if (res.data.code == 200) {
                
              }else{
                this.loginMsg=res.data.message;
                this.getCode=false;
              }
            });
        }else{
          this.getCode = false;
        }
      })
    }
  },
  //跳转隐私协议
  goAgreement(){
    let openWin = window.open('_blank','agreement');
    let str=this.$route.path.substr(1,2);
    openWin.location='/'+str+'/agreement'
  },
  //获取公钥
  getEncryptPubKey() {
    this.$ajax
      .get("/webapi/user/getEncryptPubKey")
      .then((res) => {
        if (res.data.code == 200) {
          this.pubKey = res.data.extraData.encryptPubKey;
        }
      });
  },
  /**
   * 通过公钥进行加密
   * data:要加密的数据
   */
  setEncrypt(data) {
    const jsRsa = new this.$jsEncrypt();
    //设置公钥
    jsRsa.setPublicKey(this.pubKey);
    //使用加密对象给数据加密
    let RsaData = jsRsa.encrypt(data);
    return RsaData;
  },
  //点击下一步
  submitFrom() {
    let _this = this;
    if(this.nextStepStatus){
      return;
    }
    _this.$refs['ruleForms'].validate(valid => {
      if (valid) {
        this.nextStepStatus=true;
        this.loginBtn='loading...'
        _this.$ajax
            .post("/webapi/user/registerOrLogin",{
              dappId:this.ruleForm.dappId,
              encryptAccount:this.setEncrypt(this.ruleForm.account),
              // encryptPassword:this.setEncrypt(this.$md5(this.ruleForm.password)),
              // encryptConfirmPassword:this.setEncrypt(this.$md5(this.ruleForm.passWord)),
              code:this.ruleForm.vcode,
              }
            )
            .then(res => {
              if (res.data.code == 200) {
                let partnerId= this.queryDapp.filter(item=>item.id == this.ruleForm.dappId)[0].partnerId;
                this.$emit('nextSub',{...res.data.extraData,partnerId:partnerId })
                this.loginBtn='下一步'
              }else{
                this.loginBtn='下一步'
                this.loginMsg=res.data.message;
                this.nextStepStatus=false;
              }
            });
      }else{
        this.nextStepStatus=false;
      }
    });
  },
}
};
</script>

<style scoped lang="scss">
.enterprise-login {
  width: 1106px;
  overflow: hidden;
  padding: 0px 30px;
  margin:42px auto;
  border:1px solid #E4E8EB;
  box-sizing: border-box;
  .login-title{
    width:100%;
    border-bottom: 1px solid #E5E5E5;
    height:55px;
    font-size: 18px;
    display: flex;
    align-items: center;
    color: #323232;
    img{
      margin-right: 10px;
    }
  }
  .login-desc{
    width:100%;
    height: 175px;
    border: 1px solid #E5E5E5;
    padding-top:13px;
    margin-top: 20px;
    ul{
      width:668px;
      margin:0 auto;
      li{
        height:30px;
        line-height:30px;
        font-size: 14px;
        color: #646464;
      }
    }
  }
  .login-info-checked-con{
    // margin-left: 100px;
  }
  .login-info-checked-text{
    font-size: 14px;
    color: #646464;
    padding-left: 10px;
  }
  .login-info{
    width: 480px;
    margin:0 auto;
    margin-top:48px;
  }
  .login-info-checked{
    font-size: 14px;
    color: #2A51F2;
    cursor: pointer;
  } 
  button{
    width: 368px;
    height: 36px;
    background: #2A51F2;
    border-radius: 4px;
    color: #fff;
    font-size: 14px;
    display: block;
    margin-left: 379px;
    margin-bottom:48px;
  }
  .login-error{
    width: 300px;
    position: absolute;
    left: 96%;
    top:0px;
    color: #F56C6C;
    font-size: 12px;
  }
}
</style>

<style lang="scss">
.enterprise-login{
.el-form-item {
  .el-input{
    width:360px;
    position: relative;
    .el-input__inner{
      height: 36px;
      line-height: 36px;
    }
    .el-input-group__append{
      background-color: #fff;
      height: 24px;
      width: 111px;
      border-radius: 0px;
      border-color: #ccc;
      border: 0px;
      position: absolute;
      top: 6px;
      right: 1px;
      border-left: 1px solid #ccc;
      line-height: 24px;
      padding-top: 1px;
      text-align: center;
      cursor: pointer;
    }
  }
}
.check-item{
  height: 20px;
  .el-form-item__content{
    line-height: 20px;
  }
}
.el-textarea {
  width: 100%;
}
.el-button {
  border: 1px solid #2A51F2;
  transition: all 0.7s ease-in-out 0s;
  color: #2A51F2;
}
.el-button:focus,
.el-button:hover {
  color: #fff;
  background: #2A51F2;
}
.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  color: #fff !important;
  cursor: not-allowed !important;
  background-image: none;
  background-color: #8c8c8c;
  border-color: #8c8c8c;
}

.el-form-item.is-success .el-input__inner:focus,
.el-form-item.is-success .el-textarea__inner:focus {
  border-color: #2A51F2;
}
.el-form-item.is-success .el-textarea__inner,
.el-form-item.is-success .el-input__inner {
  border-color: #D1D1D1;
}
.el-form-item__label{
  text-align:left;
  color:#5F5F5F;
}
.el-textarea__inner:focus,
.el-input__inner:focus {
  border-color: #2A51F2;
}
.el-input.is-active .el-input__inner {
  border-color: #D1D1D1;
}
.el-input__inner,
.el-textarea__inner {
  border-color: #D1D1D1;
  border-radius: 0px;
}
.el-checkbox__input.is-checked+.el-checkbox__label{
  color: #606266 !important;
}
.el-checkbox__input.is-focus .el-checkbox__inner{
  border-color: #ccc;
}
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #2A51F2 !important;
  border-color: #2A51F2 !important;
}
.el-input__inner::placeholder{
  color: #DCDCDC !important;
}

.el-form-item__error{
  top: 24%;
  left: 368px;
  width: 340px;
}
.check-item{
  .el-form-item__error{
    top: 0%;
    left: 373px;
  }
}
}
</style>

